<template>
  <div class="fccInstrucoes">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :status="status"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
            :actions="actions"
            addFilter
            :items="listarCategorias"
          >
          </fccTable>
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="imprimirInstrucao"
      :titleModal="titleInstrucao"
      size="lg"
      escondeFooter
      travaEsc
      travaBack
    >
      <div v-show="!printInstrucao">
        <fccTable
          striped
          hover
          modal
          :fields="fieldsInstrucao"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          :titlePage="titleInstrucao"
          :titlePDF="titleInstrucao"
          :items="imprimeCategorias"
          @row-selected="selecionaInstrucao"
        >
        </fccTable>

        <fcc-button
          class="w-100"
          @click="printInstrucao = true"
          :disabled="montarInstrucoes.length === 0"
        >
          Visualizar
        </fcc-button>
      </div>

      <div v-if="printInstrucao">
        <div class="text-right">
          <fcc-button
            class="border shadow-sm mr-2"
            color="light"
            icon="chevron-left"
            v-b-tooltip.hover="'Voltar'"
            @click="printInstrucao = false"
          />

          <fcc-button
            class="border shadow-sm"
            color="light"
            icon="print"
            @click="printSection('printSectionInstructioon')"
          >
            Imprimir
          </fcc-button>
        </div>

        <div :id="'printSectionInstructioon'" class="printInstrucao">
          <div class="noPrint logo">
            <img :src="logo" alt="Logo FCC" />
            <hr />
          </div>

          <div
            class="mb-1"
            v-for="listarInstrucoesPage in montarInstrucoes"
            :key="listarInstrucoesPage.insID"
          >
            <div class="printSection">
              <h1 class="titlePrintSection">{{ listarInstrucoesPage.insAssunto }}</h1>
              <b-card-text v-html="listarInstrucoesPage.insDescricao"></b-card-text>
              <b-card-text class="atualizado"
                >Atualizado: {{ listarInstrucoesPage.dataAlteracao | moment('DD/MM/YYYY hh:m:s') }}
              </b-card-text>
            </div>
          </div>
        </div>
      </div>
    </fccModal>
    <fccModal
      centered
      idModal="editCategoriasInstrucao"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="
          editarCategorias.inscatID === 0 ? addCategoriasInstrucao() : editarCategoriasInstrucao()
        "
        autocomplete="off"
      >
        <div class="row">
          <div class="col-sm-12">
            <input v-model="editarCategorias.inscatID" type="hidden" />
            <fccInput extraClasses="inputLabel" v-model="editarCategorias.inscatCodigo" required
              >Código</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="editarCategorias.inscatDescricao" required
              >Descrição</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <label>Ativo</label><br />
            <toggle-button v-model="editarCategorias.inscatAtivo" />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import './assets/scss/fccInstrucoes.scss'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Categorias de Instrução',
      titleModal: '',
      titlePDF: 'Categorias de Instrução',
      listarCategorias: [],
      editarCategorias: {},
      imprimeCategorias: {},
      montarInstrucoes: [],
      titleInstrucao: '',
      printInstrucao: false,
      baseUrlInstrucao: '',
      logo: store.state.logo,
      itemPorPage: '100',
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'imprimirInstrucoes',
          icon: 'info-circle',
          tooltip: 'Imprimir',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      status: [
        {
          funcaoButton: 'changeStatus',
          tooltip: 'Alterar Status',
          campoStatus: 'inscatAtivo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fieldsInstrucao: [
        {
          key: 'rowSelect',
          type: 'rowSelect',
          value: 'insID'
        },
        { key: 'insID', label: 'ID', sortable: true },
        { key: 'insAssunto', label: 'Instrução', sortable: true }
      ],
      fields: [
        { key: 'inscatID', label: 'ID', sortable: true, active: true },
        { key: 'inscatCodigo', label: 'Código', sortable: true, active: true },
        { key: 'inscatDescricao', label: 'Descrição', sortable: true, active: true },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          tdClass: 'no-print',
          thClass: 'no-print',
          active: true
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ]
    }
  },
  methods: {
    printSection: function (printSection) {
      this.$htmlToPaper(printSection)
    },
    selecionaInstrucao: function (itens) {
      this.montarInstrucoes = itens
    },
    imprimirInstrucoes: function (_, item) {
      this.printInstrucao = false
      this.montarInstrucoes = []
      this.carregaTexto(this.codeMensagem('C01'))
      this.titleInstrucao = 'Visualizar instruções de ' + item.inscatDescricao
      axios
        .get(
          this.baseUrlInstrucao + 'Instrucao/ListarInstrucaoPorCategoria' + item.inscatID,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.imprimeCategorias = response.data
          this.$root.$emit('bv::show::modal', 'imprimirInstrucao')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addCategoriasInstrucao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlInstrucao + 'Categoria/Adicionar',
          this.editarCategorias,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoCategorias()
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editCategoriasInstrucao')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editarCategoriasInstrucao: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .post(
          this.baseUrlInstrucao + 'Categoria/Alterar',
          this.editarCategorias,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoCategorias()
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editCategoriasInstrucao')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoCategorias: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(this.baseUrlInstrucao + 'Categoria/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listarCategorias = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.titleModal = 'Adicionar Categoria'
      this.editarCategorias = {}
      this.editarCategorias.inscatID = 0
      this.$root.$emit('bv::show::modal', 'editCategoriasInstrucao')
    },
    changeStatus: function (action, item) {
      this.editarCategorias = item
      this.editarCategoriasInstrucao()
    },
    editField: function (action, item) {
      this.titleModal = 'Editar Categoria'
      this.editarCategorias = item
      this.$root.$emit('bv::show::modal', 'editCategoriasInstrucao')
    },
    deleteField: function (action, item) {
      this.callConfirm(this.mensagemExcluir, item.inscatDescricao).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlInstrucao + 'Categoria/Excluir/' + item.inscatID,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoCategorias()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    }
  },
  mounted: function () {
    this.baseUrlInstrucao = this.$fccStore.state.baseUrlInstrucao
    this.listandoCategorias()
  }
}
</script>
